export default __webpack_public_path__ + "static/media/DOM-APR-2024.cca76994.png";